import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ONBOARDING_REPOSITORY } from './repositories/IOnboarding.repository';
import { OnboardingRepository } from './repositories/onboarding.repository';
import { ONBOARDING_SERVICE } from './services/IOnboarding.service';
import { OnboardingService } from './services/onboarding.service';
import { OnboardingBusinessConfigStore } from './state/business-config/business-config.store';
import { onboardingReducer } from './state/onboarding.reducer';
import { ONBOARDING_STORE_KEY } from './state/onboarding.selectors';
import { OnboardingStore } from './state/onboarding.store';
import { OnboardingRegistrationEffects } from './state/registration/registration.effects';
import { OnboardingRegistrationStore } from './state/registration/registration.store';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingBusinessEffects } from './state/business-config/business-config.effects';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [
    IonicModule,
    HttpClientModule,
    TranslateModule.forChild(),
    StoreModule.forFeature(ONBOARDING_STORE_KEY, onboardingReducer),
    EffectsModule.forFeature([
      OnboardingBusinessEffects,
      OnboardingRegistrationEffects,
    ]),
  ],
  exports: [],
})
export class OnboardingCoreModule {
  static forRoot(
    config?: ModuleOptionsInterface
  ): ModuleWithProviders<OnboardingCoreModule> {
    return {
      ngModule: OnboardingCoreModule,
      providers: [
        { provide: ONBOARDING_SERVICE, useClass: OnboardingService },
        {
          provide: ONBOARDING_REPOSITORY,
          useClass: OnboardingRepository,
        },
        ...(config?.providers || []),
        OnboardingRegistrationStore,
        OnboardingBusinessConfigStore,
        OnboardingStore,
      ],
    };
  }
}
